import axiosInstance from "Api";

const updateDayParts = (substitutionId,formState) => {
    return axiosInstance.patch('requisition/' + substitutionId, formState);
};

const CalendarService = {
    updateDayParts
};
export default CalendarService;